export const isCareerTechCenter = (schoolName: string, category?: string): boolean => {
  if (category) {
    const cat = category.toLowerCase();
    if (cat.includes('career') || cat.includes('tech') || cat.includes('ctc') || cat.includes('vocational') || cat.includes('applied')) {
      return true;
    }
    if (cat.includes('traditional') || cat.includes('high school')) {
      return false;
    }
  }
  const norm = (schoolName || '').toLowerCase();
  return (
    norm.includes('career center') ||
    norm.includes('technology center') ||
    norm.includes('tech center') ||
    norm.includes('applied tech') ||
    norm.includes('applied technology') ||
    norm.includes('career & tech') ||
    norm.includes('career and tech') ||
    norm.includes('vocational') ||
    norm.includes('ctc')
  );
};

export const isPostSecondarySchool = (schoolName: string, category?: string, level?: string): boolean => {
  if (level === 'Post-Secondary' || category === 'Post-Secondary') return true;
  if (category) {
    const cat = category.toLowerCase();
    if (cat.includes('post-secondary') || cat.includes('college') || cat.includes('university') || cat.includes('higher ed')) {
      return true;
    }
  }
  const norm = (schoolName || '').toLowerCase();
  return (
    norm.includes('college') ||
    norm.includes('university') ||
    norm.includes('tech college') ||
    norm.includes('technical college') ||
    norm.includes('polytechnic') ||
    norm.includes('community college') ||
    norm.includes('higher ed') ||
    norm.includes('citadel') ||
    norm.includes('musc')
  );
};

export const isTraditionalSchool = (schoolName: string, category?: string, level?: string): boolean => {
  if (isPostSecondarySchool(schoolName, category, level)) return false;
  if (isCareerTechCenter(schoolName, category)) return false;
  return true;
};

export const deriveDistrictForSchoolName = (schoolName: string | undefined, regionId?: string): string => {
  const normRegion = (regionId || '').toLowerCase().trim();
  const sNorm = (schoolName || '').toLowerCase().trim();

  // 1. Training Region & Schools
  if (
    normRegion === 'training' ||
    sNorm.includes('training') ||
    sNorm.includes('bayside') ||
    sNorm.includes('valley view')
  ) {
    return 'Training School District (training)';
  }

  // If no school name provided, fall back to region default district
  if (!sNorm) {
    if (normRegion === 'spartanburg') return 'Spartanburg School District 1 (spartanburg)';
    if (normRegion === 'charleston') return 'Charleston County School District (charleston)';
    if (normRegion === 'greenville') return 'Greenville County School District (greenville)';
    if (normRegion === 'richland') return 'Richland School District One (richland)';
    if (normRegion === 'horry') return 'Horry County Schools (horry)';
    if (normRegion === 'lexington') return 'Lexington County School District One (lexington)';
    if (normRegion === 'beaufort') return 'Beaufort County School District (beaufort)';
    if (normRegion === 'union') return 'Union County School District (union)';
    if (normRegion && normRegion !== 'global') {
      const cap = normRegion.charAt(0).toUpperCase() + normRegion.slice(1);
      return `${cap} County School District (${normRegion})`;
    }
    return 'Regional School District';
  }

  // 2. Spartanburg County (Districts 1-7)
  if (
    sNorm.includes('campobello') ||
    sNorm.includes('chapman') ||
    sNorm.includes('landrum') ||
    sNorm.includes('inman') ||
    sNorm.includes('district 1') ||
    sNorm.includes('district one')
  ) {
    return 'Spartanburg School District 1 (spartanburg)';
  }

  if (
    sNorm.includes('boiling springs') ||
    sNorm.includes('chesnee') ||
    sNorm.includes('swofford') ||
    sNorm.includes('district 2') ||
    sNorm.includes('district two')
  ) {
    return 'Spartanburg School District 2 (spartanburg)';
  }

  if (
    sNorm.includes('broome') ||
    sNorm.includes('cowpens') ||
    sNorm.includes('pacolet') ||
    sNorm.includes('middle tyger') ||
    sNorm.includes('district 3') ||
    sNorm.includes('district three')
  ) {
    return 'Spartanburg School District 3 (spartanburg)';
  }

  if (
    sNorm.includes('woodruff') ||
    sNorm.includes('district 4') ||
    sNorm.includes('district four')
  ) {
    return 'Spartanburg School District 4 (spartanburg)';
  }

  if (
    sNorm.includes('byrnes') ||
    sNorm.includes('r.d. anderson') ||
    sNorm.includes('rd anderson') ||
    sNorm.includes('r. d. anderson') ||
    sNorm.includes('duncan') ||
    sNorm.includes('district 5') ||
    sNorm.includes('district five')
  ) {
    return 'Spartanburg School District 5 (spartanburg)';
  }

  if (
    sNorm.includes('dorman') ||
    sNorm.includes('roebuck') ||
    sNorm.includes('district 6') ||
    sNorm.includes('district six')
  ) {
    return 'Spartanburg School District 6 (spartanburg)';
  }

  if (
    sNorm.includes('spartanburg high') ||
    sNorm.includes('daniel morgan') ||
    sNorm.includes('whitlock') ||
    sNorm.includes('mccracken') ||
    sNorm.includes('district 7') ||
    sNorm.includes('district seven')
  ) {
    return 'Spartanburg School District 7 (spartanburg)';
  }

  // 3. Richland County (Districts 1 and 2)
  if (
    sNorm.includes('columbia high') ||
    sNorm.includes('dreher') ||
    sNorm.includes('flora') ||
    sNorm.includes('eau claire') ||
    sNorm.includes('lower richland') ||
    sNorm.includes('keenan') ||
    sNorm.includes('heyward')
  ) {
    return 'Richland School District One (richland)';
  }

  if (
    sNorm.includes('spring valley') ||
    sNorm.includes('ridge view') ||
    sNorm.includes('blythewood') ||
    sNorm.includes('richland northeast') ||
    sNorm.includes('westwood')
  ) {
    return 'Richland School District Two (richland)';
  }

  // 4. Lexington County (Districts 1-5)
  if (
    sNorm.includes('chapin') ||
    sNorm.includes('dutch fork') ||
    sNorm.includes('irmo') ||
    sNorm.includes('spring hill')
  ) {
    return 'School District Five of Lexington & Richland Counties (lexington)';
  }

  if (
    sNorm.includes('airport') ||
    sNorm.includes('brookland-cayce') ||
    sNorm.includes('brookland cayce')
  ) {
    return 'Lexington County School District Two (lexington)';
  }

  if (
    sNorm.includes('lexington high') ||
    sNorm.includes('river bluff') ||
    sNorm.includes('white knoll') ||
    sNorm.includes('gilbert') ||
    sNorm.includes('pelion')
  ) {
    return 'Lexington County School District One (lexington)';
  }

  // 5. Charleston County
  if (
    sNorm.includes('wando') ||
    sNorm.includes('academic magnet') ||
    sNorm.includes('west ashley') ||
    sNorm.includes('charleston charter') ||
    sNorm.includes('lucy beckham') ||
    sNorm.includes('james island') ||
    sNorm.includes('burke') ||
    sNorm.includes('north charleston') ||
    sNorm.includes('charleston')
  ) {
    return 'Charleston County School District (charleston)';
  }

  // 6. Greenville County
  if (
    sNorm.includes('greenville') ||
    sNorm.includes('wade hampton') ||
    sNorm.includes('j.l. mann') ||
    sNorm.includes('jl mann') ||
    sNorm.includes('eastside') ||
    sNorm.includes('riverside') ||
    sNorm.includes('mauldin') ||
    sNorm.includes('berea') ||
    sNorm.includes('blue ridge') ||
    sNorm.includes('hillcrest') ||
    sNorm.includes('travelers rest') ||
    sNorm.includes('woodmont') ||
    sNorm.includes('golden strip') ||
    sNorm.includes('fine arts') ||
    sNorm.includes('enoree')
  ) {
    return 'Greenville County School District (greenville)';
  }

  // 7. Horry County
  if (
    sNorm.includes('myrtle beach') ||
    sNorm.includes('carolina forest') ||
    sNorm.includes('socastee') ||
    sNorm.includes('conway') ||
    sNorm.includes('aynor') ||
    sNorm.includes('loris') ||
    sNorm.includes('north myrtle') ||
    sNorm.includes('st. james') ||
    sNorm.includes('st james') ||
    sNorm.includes('green sea') ||
    sNorm.includes('horry')
  ) {
    return 'Horry County Schools (horry)';
  }

  // 8. Beaufort County
  if (
    sNorm.includes('beaufort') ||
    sNorm.includes('battery creek') ||
    sNorm.includes('bluffton') ||
    sNorm.includes('hilton head') ||
    sNorm.includes('may river') ||
    sNorm.includes('whale branch')
  ) {
    return 'Beaufort County School District (beaufort)';
  }

  // 9. Union County
  if (
    sNorm.includes('union county') ||
    sNorm.includes('union high') ||
    sNorm.includes('cate center') ||
    sNorm.includes('union')
  ) {
    return 'Union County School District (union)';
  }

  // 10. Region fallback if specified
  if (normRegion && normRegion !== 'global') {
    if (normRegion === 'spartanburg') return 'Spartanburg School District 1 (spartanburg)';
    if (normRegion === 'charleston') return 'Charleston County School District (charleston)';
    if (normRegion === 'greenville') return 'Greenville County School District (greenville)';
    if (normRegion === 'richland') return 'Richland School District One (richland)';
    if (normRegion === 'horry') return 'Horry County Schools (horry)';
    if (normRegion === 'lexington') return 'Lexington County School District One (lexington)';
    if (normRegion === 'beaufort') return 'Beaufort County School District (beaufort)';
    if (normRegion === 'union') return 'Union County School District (union)';
    const cap = normRegion.charAt(0).toUpperCase() + normRegion.slice(1);
    return `${cap} County School District (${normRegion})`;
  }

  return 'Regional School District';
};

export const deriveDistrictIdForSchoolName = (schoolName: string | undefined, regionId?: string): string => {
  const districtName = deriveDistrictForSchoolName(schoolName, regionId);
  return districtName.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
};

export interface ResolvedSchoolDistrict {
  districtName: string;
  districtId: string;
  schoolName?: string;
  schoolId?: string;
  regionId?: string;
}

/**
 * Robust Reverse Mapper:
 * Resolves the appropriate school and school district using the provided school identifier or name.
 */
export const resolveDistrictForSchool = (
  schoolInput: string | undefined,
  regionId?: string,
  allSchools: any[] = [],
  allDistricts: any[] = []
): ResolvedSchoolDistrict => {
  if (!schoolInput || !schoolInput.trim()) {
    const defaultDistName = deriveDistrictForSchoolName('', regionId);
    const defaultDistId = deriveDistrictIdForSchoolName('', regionId);
    const matchedDist = (allDistricts || []).find(d => 
      d && (d.id === defaultDistId || d.name?.toLowerCase() === defaultDistName.toLowerCase())
    );
    return {
      districtName: matchedDist?.name || defaultDistName,
      districtId: matchedDist?.id || defaultDistId,
      regionId: regionId && regionId !== 'global' ? regionId : undefined
    };
  }

  const cleanInput = schoolInput.trim();
  const inputLower = cleanInput.toLowerCase();

  // 1. Try to find the school in allSchools
  const matchedSchool = (allSchools || []).find(s => {
    if (!s) return false;
    const sId = (s.id || '').toLowerCase();
    const sName = (s.name || '').toLowerCase();
    return sId === inputLower || sName === inputLower || sName.includes(inputLower) || inputLower.includes(sName);
  });

  const effectiveSchoolName = matchedSchool?.name || cleanInput;
  const effectiveSchoolId = matchedSchool?.id || (matchedSchool ? matchedSchool.id : undefined);
  
  // Resolve effective region for the school
  let effectiveRegionId = matchedSchool?.regionId && matchedSchool.regionId !== 'global' 
    ? matchedSchool.regionId 
    : (regionId && regionId !== 'global' ? regionId : deriveRegionIdForSchool(matchedSchool || { name: effectiveSchoolName }, regionId));

  // 2. Check if matched school already has a districtId
  if (matchedSchool?.districtId) {
    const districtIdMatch = (allDistricts || []).find(d => 
      d && (d.id === matchedSchool.districtId || d.name?.toLowerCase() === matchedSchool.districtId.toLowerCase())
    );
    if (districtIdMatch) {
      return {
        schoolName: effectiveSchoolName,
        schoolId: effectiveSchoolId,
        districtName: districtIdMatch.name,
        districtId: districtIdMatch.id,
        regionId: effectiveRegionId
      };
    }
  }

  // 3. Reverse-map district by school name and region
  const derivedDistrictName = deriveDistrictForSchoolName(effectiveSchoolName, effectiveRegionId);
  const derivedDistrictId = deriveDistrictIdForSchoolName(effectiveSchoolName, effectiveRegionId);

  // 4. Try to match derived district against allDistricts
  const matchedDist = (allDistricts || []).find(d => {
    if (!d) return false;
    const dId = (d.id || '').toLowerCase();
    const dName = (d.name || '').toLowerCase();
    const targetName = derivedDistrictName.toLowerCase();
    return dId === derivedDistrictId || dName === targetName || dName.includes(targetName) || targetName.includes(dName);
  });

  return {
    schoolName: effectiveSchoolName,
    schoolId: effectiveSchoolId,
    districtName: matchedDist?.name || derivedDistrictName,
    districtId: matchedDist?.id || derivedDistrictId,
    regionId: effectiveRegionId
  };
};

export const deriveRegionIdForSchool = (school: { name: string; regionId?: string }, activeTenantId?: string): string => {
  if (school.regionId && school.regionId !== 'global') {
    return school.regionId;
  }
  const sNorm = (school.name || '').toLowerCase();
  if (
    sNorm.includes('spartanburg') || sNorm.includes('chapman') || sNorm.includes('landrum') ||
    sNorm.includes('campobello') || sNorm.includes('boiling springs') || sNorm.includes('chesnee') ||
    sNorm.includes('broome') || sNorm.includes('woodruff') || sNorm.includes('byrnes') ||
    sNorm.includes('dorman') || sNorm.includes('swofford') || sNorm.includes('daniel morgan') ||
    sNorm.includes('r.d. anderson') || sNorm.includes('whitlock')
  ) {
    return 'spartanburg';
  }
  if (sNorm.includes('charleston') || sNorm.includes('wando') || sNorm.includes('west ashley')) {
    return 'charleston';
  }
  if (sNorm.includes('greenville') || sNorm.includes('wade hampton') || sNorm.includes('j.l. mann') || sNorm.includes('eastside') || sNorm.includes('riverside')) {
    return 'greenville';
  }
  if (sNorm.includes('columbia') || sNorm.includes('dreher') || sNorm.includes('spring valley') || sNorm.includes('ridge view') || sNorm.includes('richland')) {
    return 'richland';
  }
  if (sNorm.includes('myrtle beach') || sNorm.includes('carolina forest') || sNorm.includes('socastee') || sNorm.includes('conway') || sNorm.includes('horry')) {
    return 'horry';
  }
  if (sNorm.includes('training') || sNorm.includes('bayside') || sNorm.includes('valley view')) {
    return 'training';
  }
  if (activeTenantId && activeTenantId !== 'global') {
    return activeTenantId;
  }
  return 'spartanburg';
};

export const getPostSecondarySchoolsForRegion = (regionId: string): Array<{ id: string; name: string; regionId: string; level: string }> => {
  const normId = (regionId || '').toLowerCase();
  
  if (normId === 'spartanburg') {
    return [
      { id: 'converse-university-(spartanburg)', name: 'Converse University (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
      { id: 'spartanburg-community-college-(spartanburg)', name: 'Spartanburg Community College (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
      { id: 'wofford-college-(spartanburg)', name: 'Wofford College (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
      { id: 'usc-upstate-(spartanburg)', name: 'USC Upstate (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
      { id: 'spartanburg-methodist-college-(spartanburg)', name: 'Spartanburg Methodist College (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
      { id: 'sherman-college-of-chiropractic-(spartanburg)', name: 'Sherman College of Chiropractic (spartanburg)', regionId: 'spartanburg', level: 'Post-Secondary' },
    ];
  }
  
  if (normId === 'greenville') {
    return [
      { id: 'greenville-technical-college-(greenville)', name: 'Greenville Technical College (greenville)', regionId: 'greenville', level: 'Post-Secondary' },
      { id: 'furman-university-(greenville)', name: 'Furman University (greenville)', regionId: 'greenville', level: 'Post-Secondary' },
      { id: 'bob-jones-university-(greenville)', name: 'Bob Jones University (greenville)', regionId: 'greenville', level: 'Post-Secondary' },
    ];
  }

  if (normId === 'charleston') {
    return [
      { id: 'college-of-charleston-(charleston)', name: 'College of Charleston (charleston)', regionId: 'charleston', level: 'Post-Secondary' },
      { id: 'trident-technical-college-(charleston)', name: 'Trident Technical College (charleston)', regionId: 'charleston', level: 'Post-Secondary' },
      { id: 'the-citadel-(charleston)', name: 'The Citadel (charleston)', regionId: 'charleston', level: 'Post-Secondary' },
      { id: 'medical-university-of-south-carolina-(charleston)', name: 'Medical University of South Carolina (charleston)', regionId: 'charleston', level: 'Post-Secondary' },
    ];
  }

  if (normId === 'richland') {
    return [
      { id: 'university-of-south-carolina-(richland)', name: 'University of South Carolina (richland)', regionId: 'richland', level: 'Post-Secondary' },
      { id: 'midlands-technical-college-(richland)', name: 'Midlands Technical College (richland)', regionId: 'richland', level: 'Post-Secondary' },
      { id: 'benedict-college-(richland)', name: 'Benedict College (richland)', regionId: 'richland', level: 'Post-Secondary' },
      { id: 'allen-university-(richland)', name: 'Allen University (richland)', regionId: 'richland', level: 'Post-Secondary' },
    ];
  }

  if (normId === 'horry') {
    return [
      { id: 'coastal-carolina-university-(horry)', name: 'Coastal Carolina University (horry)', regionId: 'horry', level: 'Post-Secondary' },
      { id: 'horry-georgetown-technical-college-(horry)', name: 'Horry-Georgetown Technical College (horry)', regionId: 'horry', level: 'Post-Secondary' },
    ];
  }

  return [
    { id: 'regional-technical-college', name: 'Regional Technical College', regionId: normId || 'global', level: 'Post-Secondary' },
    { id: 'state-university', name: 'State University', regionId: normId || 'global', level: 'Post-Secondary' },
  ];
};
